/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useMemo} from 'react';
// material
import {Switch, ToolTip} from '@insticator/insticator-ui';
import ContentScroller from '../../../../../../material/contentscroller/contentscroller';
import EmojiIcon from '../../../../../../material/emojiicon/emojiicon';
// data
import {EmojiCategoriesTitles, getEmoji, getEmojiIcon} from '../emojiList';
// styles
import injectSheet from 'react-jss';
import styles from './rowitem_styles';

export const LIMIT_ACTIVE_EMOJIS = 2

/* ========== ~~~~~~~~~~ ROW ITEM - EMOJI CONFIG ~~~~~~~~~~ ========== */
const RowItem = injectSheet(styles)((props) => {
  const {
    active,
    emojiCategory: {
      emojiName,
      emojiCategoryType,
    } = {},
    emojiUUID,
    lastUpdatedAt,
    handleActivateEmoji,
    handleSelectEmojiCategory,
    filteredCategories,
    isLimitActiveEmojis,
  } = props;

  const emoji = useMemo(() => getEmoji(emojiName), [emojiName]);

  return (
    <tr className={`${props.classes.rowitem}`}>
      <td className={'name'}>{(emoji?.title || emojiName)?.toLowerCase()}</td>
      <td className={'status'}>
        {active && isLimitActiveEmojis && <ToolTip
          position={'top-start'}
          trigger={'mouseenter focus'}
          content={`At least ${LIMIT_ACTIVE_EMOJIS} emojis must be enabled`}
          zIndex={9999}
        >
          <span><Switch
            variant={'primary'}
            isStatic={false}
            on={active}
            handleClick={() => handleActivateEmoji(!active, emojiUUID)}
          /></span>
        </ToolTip>}
        {(!active || !isLimitActiveEmojis) && <Switch
          variant={'primary'}
          isStatic={false}
          on={active}
          handleClick={() => handleActivateEmoji(!active, emojiUUID)}
        />}
      </td>
      <td className={'current'}>
        <span className={'lastupdated'}>
          <EmojiIcon src={getEmojiIcon({emojiName, emojiCategoryType})}/>
          <span className={'lastupdate'}>{lastUpdatedAt}</span>
        </span>
      </td>
      <td className={'category'}>
        <ContentScroller
          showcase={filteredCategories.map(category =>
            <ToolTip
              key={category}
              position={'top'}
              trigger={'mouseenter focus'}
              content={EmojiCategoriesTitles[category]}
              zIndex={9999}
            >
              <EmojiIcon
                src={getEmojiIcon({emojiName, emojiCategoryType: category})}
                isActive={emojiCategoryType?.toLowerCase() === category?.toLowerCase()}
                handleClick={() => handleSelectEmojiCategory(emojiName, category, emojiUUID)}
              />
            </ToolTip>
          )}
          forward={() => console.log('scroll forward')}
          backward={() => console.log('scroll backward')}
        />
      </td>
    </tr>
  )
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default RowItem;
